import { Route } from './route';
export const middleware = (rule) => route => void route.rules.push(rule);
export const expr = (regexp) => route => middleware((next, _prev, pathname) => {
    regexp.lastIndex = Route.lastIndex;
    const matches = regexp.exec(pathname);
    DEBUG: route.VERBOSE && console.debug('voyager/config expr', { alias: route.name, matches, route });
    if (!matches) {
        return false;
    }
    Route.lastIndex = regexp.lastIndex;
    if (!route.isVirtual && Route.lastIndex > Route.lastIndexMax) {
        Route.lastIndexMax = Route.lastIndex;
    }
    if (matches.groups) {
        Object.assign(next, matches.groups);
    }
    return true;
})(route);
export const path = (path) => expr(new RegExp(path.replace(/\{(.+?)\}/g, '(?<$1>[^/?]+)'), 'y'));
export const exact = (exactPath) => path(`${exactPath}$`);
export const validate = (validator) => middleware(validator);
export const incomplete = route => void (route.isVirtual = true);
export const index = expr(/$/y);
export const create = (...config) => route => route.create(...config);
export const createMany = (...configs) => route => route.createMany(...configs);
export const alias = (name) => route => {
    DEBUG: route.VERBOSE && console.debug('voyager/config alias', name);
    route.name = name;
};
export const on = (type, callback, options) => route => {
    route.addEventListener(type, callback, options);
};
export const listen = on;
export const DEBUG = route => {
    DEBUG: {
        route.VERBOSE = true;
        console.warn(`voyager/route Enable verbose debug messages.`, { route });
    }
};
